import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import AdminLayout from '@/components/AdminLayout';
import ProtectedRoute from '@/components/ProtectedRoute';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import DashboardPage from '@/pages/DashboardPage';
import ProfilePage from '@/pages/ProfilePage';
import UtilizadoresPage from '@/pages/UtilizadoresPage';
import ParticipantePage from '@/pages/ParticipantePage';
import ParentalConsentPage from '@/pages/ParentalConsentPage';
import EncarregadosPage from '@/pages/EncarregadosPage';
import PedidosPrivacidadePage from '@/pages/PedidosPrivacidadePage';
import CentrosDigitaisPage from '@/pages/CentrosDigitaisPage';
import EquipamentosPage from '@/pages/EquipamentosPage';
import EquipmentLabelsPage from '@/pages/EquipmentLabelsPage';
import BadgesPage from '@/pages/BadgesPage';
import AtividadesPage from '@/pages/AtividadesPage';
import PresencasPage from '@/pages/PresencasPage';
import AtividadeDetailPage from '@/pages/AtividadeDetailPage';
import ActivitySessionPage from '@/pages/ActivitySessionPage';
import MensagensPage from '@/pages/MensagensPage';
import ReportsPage from '@/pages/ReportsPage';
import EquipmentAssignmentsPage from '@/pages/EquipmentAssignmentsPage';
import AdminUsersPage from '@/pages/AdminUsersPage';

export default function App() {
  const { isAuthenticated } = useAuthStore();

  return (
    <Routes>
      {/* Public routes */}
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />}
      />
      <Route
        path="/register"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <RegisterPage />}
      />
      <Route
        path="/forgot-password"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <ForgotPasswordPage />}
      />
      <Route
        path="/reset-password"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <ResetPasswordPage />}
      />

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        {/* Outside the backoffice's frame: what is printed is the sheets alone. */}
        <Route path="/equipamentos/etiquetas" element={<EquipmentLabelsPage />} />
        <Route element={<AdminLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/users" element={<UtilizadoresPage />} />
          <Route path="/users/:id" element={<ParticipantePage />} />
          <Route path="/presencas" element={<PresencasPage />} />
          <Route path="/parental-consent" element={<ParentalConsentPage />} />
          <Route path="/encarregados" element={<EncarregadosPage />} />
          <Route path="/pedidos-privacidade" element={<PedidosPrivacidadePage />} />
          <Route path="/centros-digitais" element={<CentrosDigitaisPage />} />
          <Route path="/equipamentos" element={<EquipamentosPage />} />
          <Route path="/credenciais" element={<BadgesPage />} />
          <Route path="/atividades" element={<AtividadesPage />} />
          {/* Declared before /:id so "sessoes" is never read as an activity id. */}
          <Route path="/atividades/sessoes/:id" element={<ActivitySessionPage />} />
          <Route path="/atividades/:id" element={<AtividadeDetailPage />} />
          <Route path="/mensagens" element={<MensagensPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/equipamentos-utilizadores" element={<EquipmentAssignmentsPage />} />
          <Route path="/admin-users" element={<AdminUsersPage />} />
        </Route>
      </Route>

      {/* Default redirect */}
      <Route path="*" element={<Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />} />
    </Routes>
  );
}
